
export const guidelineData = [
    {
        id: 1,
        image: "https://i.ibb.co/5Rn62D1/guideline-1.jpg",
        title: "Start an online business and....",
        info: "Are you tired of the 9 to 5 grind and...."
    },
    {
        id: 2,
        image: "https://i.ibb.co/FWL3Tt6/guideline-2.jpg",
        title: "Digital marketing made easy",
        info: "In today's digital age, marketing your.... "
    },
    {
        id: 3,
        image: "https://i.ibb.co/Xb0bGrt/guideline-3.jpg",
        title: "Create a logo for your business",
        info: "Creating a professional logo is a...."
    },
]